import { SubscriptionUserPriceData, SubscriptionUserPriceListQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export interface FilterParams extends SubscriptionUserPriceListQuery {}

export class SubscriptionUserPriceList extends LongList<
    SubscriptionUserPriceData,
    SubscriptionUserPriceData,
    FilterParams
> {
    public static Name = 'subscriptionUserPriceList' as const;
    public readonly limit: number = 50;

    protected create(params: SubscriptionUserPriceData): SubscriptionUserPriceData {
        return params;
    }

    protected filterValue(value: SubscriptionUserPriceData, { authorId, status }: FilterParams): boolean {
        return (
            this.filterFieldValueByArray(value, authorId, 'authorId') &&
            this.filterFieldValueByArray(value, status, 'status')
        );
    }
}

export const subscriptionUserPriceList = new SubscriptionUserPriceList();
